// start:ng42.barrel
export * from './make-another-reservation.component';
// end:ng42.barrel



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/make-another-reservation/index.ts